<script>
import { getCurrentInstance, ref, inject, defineComponent } from "@vue/composition-api";
import SectionTransformTable from "../ultils/Section/SectionTransformTable.vue";

import FormItems from "../ultils/Form/FormItems.vue";
import EzTable from "../ultils/Table/EzTable.vue";

import SearchList from "../ultils/SearchList/SearchList.vue";

import { arClient } from "@/api/ar-client";

import { useFetch } from "../ultils/Hooks/useFetch.ts";
import PermissionButton from "../ultils/Button/PermissionButton.vue";

import ModalSMS from "./ModalSMS.vue";
import { convertSmsDistributionStatus, SmsDistributionStatus } from "../ultils/status";
import { AR_DSMS01, AR_RSMS02, AR_IPSMS01 } from "@/api/constant";

export default defineComponent({
  components: {
    PermissionButton,
    EzTable,
    FormItems,
    SearchList,
    ModalSMS,
    SectionTransformTable,
  },
  setup() {
    const detailData = ref({});
    const selectedDistributionAccount = ref([]);
    const vm = getCurrentInstance().proxy;

    const columns = ref([
      {
        caption: "ar_client_debt_account",
        field: "ArAccountCode",
        width: "130px",
      },
      {
        caption: "ar_common_company_code",
        field: "ArTravelAgentCode",
        width: "130px",
      },
      {
        caption: "ar_client_company_name",
        field: "ArTravelAgentName",
        width: "10%",
      },
      {
        caption: "ar_client_site_code",
        field: "PropertyCode",
        cellTemplate: true,
        width: "10%",
        cellRender(data) {
          return `${data.data?.PropertyCode} - ${data.data?.PropertyName}`;
        },
      },
      {
        formatType: "currency",
        caption: "ar_client_total_money",
        field: "Amount",
        width: "10%",
        cellTemplate: true,
      },
      /* {
     
        caption: "ar_client_currency_code",
        field: "CurrencyFormat",
        
      }, */
      {
        caption: "ar_client_content",

        field: "Message",
      },
      {
        caption: "ar_client_allotment_states",
        cellTemplate: true,

        width: "8%",
        formatType: "text-variant",
        renderTextVariant: convertSmsDistributionStatus,
        field: "Status",
      },
      {
        formatType: "date",
        caption: "ar_client_created_date",
        field: "CreatedDate",
        width: "9%",
        cellTemplate: true,
      },
    ]);
    const actions = ref([
      {
        apiCode: AR_RSMS02,
        title: "ar_common_detail",
        icon: "eye",
      },
      {
        apiCode: AR_DSMS01,
        danger: true,
        icon: "trash",
        title: "ar_common_delete",
      },
      /* {
    danger: true,
    icon:"trash",
    title: "ar_common_delete",
  },
  {
    danger: true,
    icon:"trash",
    title: "ar_common_delete",
  },
  {
    danger: true,
    icon:"trash",
    title: "ar_common_delete",
  }, */
    ]);

    const isShowModal = ref(false);
    /* const dataSource = ref([]); */
    const formData = ref({});

    const formItems = ref([
      {
        type: "string",
        name: "ArAccountCode",
        label: "ar_client_debit_account",
        placeholder: "ar_client_debit_account",
        wrapperClass: "col-2",
      },
      {
        type: "select",
        name: "ArTravelAgentCode",
        dataSource: arClient.api_AR_RCL01,
        multiple: true,
        dataSourceParams: {
          IsCheckPermission: false,
        },
        customReduce: "TravelAgentCode",
        customOptions: (options) =>
          options.map((opt) => ({ ...opt, CodeName: `${opt.TravelAgentCode} - ${opt.NameVi}` })),
        labelOption: "CodeName",
        label: "ar_client_company",
        placeholder: "ar_client_company",
        wrapperClass: "col-3",
      },
      {
        type: "select",
        name: "Status",
        dataSource: SmsDistributionStatus.map((i) => ({ ...i, title: vm.$t(i.title) })),

        customReduce: "value",
        labelOption: "title",

        label: "ar_client_allotment_states",
        placeholder: "ar_client_allotment_states",
        wrapperClass: "col-3",
      },
      {
        type: "date",
        rangeData: ["FromDate", "ToDate"],
        name: "createdDate",
        isRange: true,
        placeholder: "ar_client_created_date",
        label: "ar_client_created_date",
        wrapperClass: "col-3",
      },
    ]);
    const tableRef = ref(null);

    const refetchData = () => {
      tableRef.value.fetchData(/* tableRef.value.rawDataSourceParams */);
    };

    const { fetchData: deleteData } = useFetch(arClient.api_AR_DSMS01, {
      showLoading: true,
      loadingMessage: "ar_common_deleting",
      nextFunction: refetchData,
    });
    const {
      fetchData: fetchDetailData,
      data: detailDataFetched,
      isError,
    } = useFetch(arClient.api_AR_RSMS02, {
      showLoading: true,
      loadingMessage: "ar_common_get_detail",
      disableSuccessMessage: true,
    });
    const { fetchData: distributeAccount } = useFetch(arClient.api_AR_IPSMS01, {
      showLoading: true,
      disableSuccessMessage: true,
      nextFunction: () => {
        vm.swal({
          cancelButtonText: "Ở lại",
          showCancelButton: true,
          icon: "success",
          text: "Bạn có muốn chuyển sang màn danh sách tài khoản phân bổ chờ chi ?",
          title: "Tạo phân bổ thành công",
        }).then((result) => {
          refetchData();
          if (result.isConfirmed) {
            vm.$router.push({ name: "list-pay-distribution" });
          }
        });
      },
    });

    const onSelectionChanged = (value) => {
      selectedDistributionAccount.value = value.selectedRowsData.map((d) => ({ Id: d.Id }));
    };
    const handleDistributeAccount = () => {
      if (selectedDistributionAccount.value.length === 0) {
        vm.showToast("error", vm.$t("ar_distribution_err_msg_02"));
        return;
      }
      distributeAccount({
        ArPaymentSMSDetail: selectedDistributionAccount.value.map((acc) => ({ Id: acc.Id })),
      });
    };

    const viewDetailSMS = async (data) => {
      await fetchDetailData({
        ArPaymentSMSDetail: { Id: data.data.Id },
      });

      if (!isError.value) {
        detailData.value = detailDataFetched.value;

        isShowModal.value = true;
      }
    };
    return {
      AR_IPSMS01,
      viewDetailSMS,
      handleDistributeAccount,
      refetchData,
      deleteData,
      detailData,
      tableRef,
      isShowModal,
      formData,
      formItems,
      onSelectionChanged,
      viewDetailSMS,
      actions,
      columns,
      handleDistributeAccount,
    };
  },
});
</script>
<template>
  <SectionTransformTable>
    <ModalSMS @refetch="refetchData" :data="detailData" :isShow.sync="isShowModal" />

    <SearchList
      :title="$t('ar_client_message')"
      buttonText="ar_common_search"
      @search="refetchData"
    >
      <FormItems :formData.sync="formData" :items="formItems" />
    </SearchList>
    <b-card>
      <EzTable
        :selectionConfig="{
          hideSelectAll: true,
          hideSelect: !isValidPermission(AR_IPSMS01),
        }"
        ref="tableRef"
        :excelExport="arClient.api_ExcelAP_RSMS01"
        excel-export-api-code="AR_RSMS03"
        @selection-changed="onSelectionChanged"
        :dataSourceParams="formData"
        @action-1="viewDetailSMS"
        @action-2="
          (data) =>
            deleteData({
              ArPaymentSMSDetail: { Id: data.data.Id },
            })
        "
        :actions="actions"
        :columns="columns"
        :dataSource="arClient.api_AR_RSMS01"
      >
        <!--   <template #toolbar>
          <PermissionButton
            :api-code="AR_IPSMS01"
            @click="handleDistributeAccount"
            variant="outline-primary"
          >
            <ez-icon icon="ezAr-icon-plus-circle" />
            {{ $t("ar_client_distribution") }}
          </PermissionButton>
        </template> -->
      </EzTable>
    </b-card>
  </SectionTransformTable>
</template>
